import { render, staticRenderFns } from "./reLogin.vue?vue&type=template&id=3405fd2d&scoped=true&"
import script from "./reLogin.vue?vue&type=script&lang=js&"
export * from "./reLogin.vue?vue&type=script&lang=js&"
import style0 from "./reLogin.vue?vue&type=style&index=0&id=3405fd2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405fd2d",
  null
  
)

export default component.exports